export interface BasicCostDetail {
  id: number;
  appraisal_name: string;
}

// to single object maping
export const mapBasicCostDetail = (data: any): BasicCostDetail => {
  if (!data) {
    throw new Error("Invalid Data");
  }
  const res: BasicCostDetail = {
    id: data.id,
    appraisal_name: data.appraisal_name,
  };
  return res;
};

// maping list objects
export const mapBasicCostDetails = (data: any[]): BasicCostDetail[] => {
  if (!Array.isArray(data)) {
    throw new Error("Invalid Data");
  }
  return data.map(mapBasicCostDetail);
};
